// useDownloadImage.ts
import { useCallback } from "react";

export function useDownloadImage() {
    return useCallback(async (url: string, filename = "image.jpg") => {
        try {
            const res = await fetch(url);
            if (!res.ok) throw new Error("Failed to fetch image");

            const blob = await res.blob();
            const ext = blob.type.split("/")[1] || "jpg";

            const fileName = filename.includes(".") ? filename : `${filename}.${ext}`;

            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Image download failed:", err);
        }
    }, []);
}
